import React from 'react';
import ReportStatusBadge from '../../../utils/ReportStatusBadge';
import { Link } from 'react-router-dom';
import { FileText, ChevronRight } from 'lucide-react';
import { ComponentRead } from '../../../api/apiTypes';
import { formatDriverRoute } from '../../../utils/Format';
import EventList from '../../../utils/EventList';
import { routesMap } from '../../../routes/AppRoutes';

type ContainerListaDriverPageProps = {
  drivers: ComponentRead[];
  reportId: string | undefined;
  id: string;
  events: any[];
};

const ContainerListaDriverPage = ({ drivers, reportId, id, events }: ContainerListaDriverPageProps) => {
  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-base font-semibold text-[#1B365D]">Driver di analisi</h2>
        <p className="text-xs text-gray-400 mt-0.5">{drivers.length} driver disponibili</p>
      </div>

      <div className="space-y-2">
        {drivers.map((driver) => {
          const routeSuffix = formatDriverRoute(driver.name);
          const linkTo = routeSuffix && reportId
            ? routesMap.VISUALIZZA_DRIVER(reportId, routeSuffix)
            : '#';
          const driverId = driver.id;

          return (
            <Link
              key={driver.id}
              to={linkTo}
              state={{ id, driverId }}
              className="flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:border-[#1B365D]/20 hover:shadow-sm transition-all group"
            >
              <div className="w-9 h-9 rounded-lg bg-gray-50 group-hover:bg-[#1B365D]/5 flex items-center justify-center transition-colors shrink-0">
                <FileText className="w-4 h-4 text-[#1B365D]/60" />
              </div>

              <div className="flex-1 min-w-0">
                <span className="text-sm font-semibold text-[#1B365D]">{driver.name}</span>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <ReportStatusBadge stato={driver.status} />
                <ReportStatusBadge stato={driver.validation} />
                <div className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-300 group-hover:text-[#1B365D] group-hover:bg-[#1B365D]/5 transition-colors">
                  <ChevronRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="text-sm text-gray-500">
        <EventList events={events} />
      </div>
    </div>
  );
};

export default ContainerListaDriverPage;
